import {api} from 'api/setup';
import {IPromoCategoryResponse} from 'types';

export const getPromoCategory = (): Promise<IPromoCategoryResponse[]> => {
  return api.get(`/promo-category`);
};

export const getPromoCategoryMarkets = (): Promise<IPromoCategoryResponse[]> => {
  return api.get(`/promo-category?type=market`);
};
